import * as React from 'react';
import IndexLink from '../../common/IndexLink';
import { ProspectPage, prospectPath, prospectPages } from './ProspectRouter';
import { prospectLoggedIn, clearToken, getMyFirstName } from '../../../utilities/identity';
import { browserHistory } from '../../../utilities/history';
import ProspectIndexPageSearch from './ProspectIndexPageSearch';

const ProspectIndexLink = (page: ProspectPage) =>
    page.icon && page.displayText ? (
        <IndexLink
            iconSrc={page.icon}
            text={page.displayText}
            destinationRoute={prospectPath(page)}
        />
    ) : null;

const logOut = () => {
    clearToken();
    browserHistory.push(prospectPath(prospectPages.welcome));
};

const ProspectIndexPage = () => {
    const myFirstName = getMyFirstName();

    return (
        <div>
            <div className="index-text">
                <b>{myFirstName ? `Welcome, ${myFirstName}!` : 'Welcome!'}</b>
            </div>
            {prospectLoggedIn() ? (
                <>
                    <ProspectIndexPageSearch />
                    <ProspectIndexLink {...prospectPages.tours} />
                    <ProspectIndexLink {...prospectPages.profile} />
                    <ProspectIndexLink {...prospectPages.preferences} />
                </>
            ) : (
                <ProspectIndexLink {...prospectPages.register} />
            )}

            <ProspectIndexLink {...prospectPages.aboutUs} />
            <ProspectIndexLink {...prospectPages.tour24Faq} />
            <ProspectIndexLink {...prospectPages.help} />
            <section className="log-an">
                {prospectLoggedIn() && (
                    <span onClick={logOut} className="index-page-log-out">
                        Sign Out
                    </span>
                )}
            </section>
        </div>
    );
};

export default ProspectIndexPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/ProspectIndexPage.tsx